// Canonical JSON — JSON.stringify with object keys sorted, recursively.
//
// Why: the storage layer decides whether a Firestore document needs writing by
// comparing a serialization of the payload against the last one it wrote
// (lastWrittenHash in js/services/firebase-auth.js). Plain JSON.stringify is
// key-ORDER sensitive, and the order is not stable here: local objects keep
// their insertion order while Firestore hands keys back sorted, so every sync
// round-trip reshuffles them. Identical data then serialized differently and
// every "unchanged" document was rewritten anyway — which silently defeated the
// whole skip mechanism, and with it the per-round split and the meta-doc skip.
//
// Only used for comparison. What actually gets written to Firestore is the
// original object, untouched.

function canonical(value) {
    if (Array.isArray(value)) return value.map(canonical);
    // Order matters only for plain objects; null is typeof 'object' but has no keys.
    if (value && typeof value === 'object') {
        const out = {};
        Object.keys(value).sort().forEach(key => { out[key] = canonical(value[key]); });
        return out;
    }
    return value;
}

export function stableStringify(value) {
    return JSON.stringify(canonical(value));
}
